import type { ExternalTableSchema } from '@packages/table-builder';

export const performanceRuleApprovalTable: ExternalTableSchema = {
  metadata: {
    title: 'Performance Rule Approval Requests',
    entity: 'Performance Rule Approval',
    description: 'List of performance rule approval requests for your company.',
  },

  dataSource: {
    endpoint: '/api/award/api/app/performance-rule-approval/approval-performance-rule-list',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      Filter: 'table.searchText',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
      EvaluationPeriodFrom: 'filters.createdFromDate',
      EvaluationPeriodTo: 'filters.createdToDate',
      RuleStatus: 'filters.ruleStatusId',
      ApprovalStatus: 'filters.approvalStatusId',
    },
    filters: [
      {
        name: 'createdFromDate',
        placeholder: 'Evaluation Period From',
        type: 'date',
      },
      {
        name: 'createdToDate',
        placeholder: 'Evaluation Period To',
        type: 'date',
      },
      {
        name: 'ruleStatusId',
        placeholder: 'Available Status',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/award/api/app/performance-rule-approval/rule-available-status-list',
          labelField: 'name',
          valueField: 'id',
        },
      },
      {
        name: 'approvalStatusId',
        placeholder: 'Approval Status',
        type: 'asyncSelect',
        multiple: true,
        dataSource: {
          url: '/api/award/api/app/performance-rule-approval/rule-approval-status-list',
          labelField: 'name',
          valueField: 'id',
        },
        additionalOption: { label: 'All', value: 0 },
      },
    ],
  },

  columns: [
    { field: 'ruleName', header: 'Rule Name', type: 'text', sortable: true, width: 200 },
    {
      field: 'createDate',
      header: 'Created Date',
      type: 'date',
      sortable: true,
      width: 150,
      align: 'center',
    },
    { field: 'createdBy', header: 'Created By', type: 'text', sortable: true, width: 200 },
    {
      field: 'evaluationPeriodFrom',
      header: 'Evaluation Start Date',
      type: 'date',
      sortable: true,
      width: 200,
      align: 'center',
    },
    {
      field: 'evaluationPeriodTo',
      header: 'Evaluation End Date',
      type: 'date',
      sortable: true,
      width: 200,
      align: 'center',
    },
    {
      field: 'minimumPercentage',
      header: 'Minimum',
      type: 'percentage',
      sortable: true,
      width: 80,
      align: 'center',
    },
    {
      field: 'maximumPercentage',
      header: 'Maximum',
      type: 'percentage',
      sortable: true,
      width: 80,
      align: 'center',
    },
    {
      field: 'approvalStatus',
      header: 'Approval Status',
      type: 'badge',
      sortable: true,
      width: 180,
      align: 'center',
      badge: {
        statusMap: {
          Approved: 'success',
          Rejected: 'error',
          Pending: 'info',
        },
        defaultVariant: 'info',
      },
    },
    {
      field: 'availableStatus',
      header: 'Available Status',
      type: 'badge',
      sortable: true,
      width: 180,
      align: 'center',
      badge: {
        statusMap: {
          Available: 'success',
          Unavailable: 'error',
        },
        defaultVariant: 'info',
      },
    },
    {
      field: 'earnedStatus',
      header: 'Earned Status',
      type: 'badge',
      sortable: true,
      width: 180,
      align: 'center',
      badge: {
        statusMap: { Earned: 'success' },
        defaultVariant: 'info',
      },
    },
    {
      field: 'isEvaluated',
      header: 'Evaluated Status',
      type: 'badge',
      width: 180,
      align: 'center',
      visibility: 'picker',
      badge: {
        statusMap: { true: 'success', false: 'error' },
        defaultVariant: 'info',
      },
      conditionalValues: { true: 'Evaluated', false: 'Not Evaluated' },
    },
  ],

  actions: {
    row: [
      { id: 'VIEW_PERFORMANCE_RULE_APPROVAL', label: 'View' },
      { id: 'APPROVE_PERFORMANCE_RULE_APPROVAL', label: 'Approve' },
      { id: 'REJECT_PERFORMANCE_RULE_APPROVAL', label: 'Reject', variant: 'danger' },
      { id: 'VIEW_COMMENTS_PERFORMANCE_RULE_APPROVAL', label: 'View Comments' },
    ],
  },

  features: {
    search: { enabled: true },
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    columnPreferences: {
      persistenceKey: 'Performance Approval',
      resizable: true,
      reorderable: true,
    },
  },
};
